import { TimeSwitch } from "src/utils/fw"
import { isMember } from "../utils"
import { auditoriumCloseDate } from "../utils"

export const Navbar = () => <div class="venue-navbar-wrapper">
	<div class="topnavtk2 left-nav" id="myTopnavtk2">
		<a href="https://isfcongress.tkeventsregistration.com/2023" id="LeaveEvent" class="activetk2">Leave Event</a>
		{
			// isMember && <>
			// 	<div class="dropdowntk2">
			// 		<button class="dropbtntk2">Schedule
			// 			<i class="fa fa-caret-down" />
			// 		</button>
			// 		<div class="dropdown-contenttk2">
			// 			<a href="https://isfcongress.tkeventsregistration.com/2023/personalschedule" title="Personal Agenda" target="_blank">Personal Agenda</a>
			// 			<a href="https://isfcongress.tkeventsregistration.com/2023/fullschedule" title="Full Schedule" target="_blank">Full Schedule</a>
			// 		</div>
			// 	</div>
			// </>
		}
		<div class="dropdowntk2">
			<button class="dropbtntk2">Rooms
				<i class="fa fa-caret-down" />
			</button>
			<div class="dropdown-contenttk2">
				<a href="/atrium" title="Atrium">Atrium</a>
				<TimeSwitch>
					{[
						{
							starts: new Date("2023-10-22 08:00:00+0200"),
							ends: auditoriumCloseDate,
							content: <>
								{isMember && <a href="/auditorium" title="Auditorium 1">Auditorium 1</a>} 
								{isMember && <a href="/auditorium-two" title="Auditorium 2">Auditorium 2</a>}
							</>
						},
						{
							starts: auditoriumCloseDate,
							ends: new Date("2024-10-24 14:00:00+0200"),
							content: <></>
						}
					]}
				</TimeSwitch>
				<a href="/exhibition-hall" title="Exhibition Hall">Exhibition Hall</a>
				{isMember && <a href="/exploration-zone" title="ISF Exploration Zone">ISF Exploration Zone</a>}
				{isMember && new Date() > new Date("2023-10-23 08:00:00+0200") && <a href="/on-demand" title="on-demand">On Demand</a>}

			</div>
		</div>
		{
			isMember
			? <>
				<a href="https://isfcongress.tkeventsregistration.com/2023/attendeedirectory" title="Attendee Directory" target="_blank">Attendee Directory</a>
				<a href="https://isfcongress.tkeventsregistration.com/2023/meettheisfteam" title="Meet the ISF Experts" target="_blank">Meet the ISF Experts</a>
				<a href="https://isfcongress.tkeventsregistration.com/2023/sponsordirectory" title="Sponsor Directory" target="_blank">Sponsor Directory</a>
			</>
			: <>
				<a href="https://isfcongress.tkeventsregistration.com/2023/meettheisfteam" title="Meet the ISF Experts" target="_blank">Meet the ISF Experts</a>
				<a href="https://isfcongress.tkeventsregistration.com/2023/sponsordirectory" title="Sponsor Directory" target="_blank">Sponsor Directory</a>
			</>
		}
	</div>
	{
		isMember && window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes" && <>
			<div class="gamification-buttons-wrapper topnavtk2">
				<a class="gamification-button" id="how-to-earn" style="cursor: pointer" title="How to Earn Points">How to Earn Points</a>
				<a style="cursor: pointer" onclick={() => { document.getElementById("Leaderboard").click() }} title="Leaderboard">Leaderboard</a>
			</div>
		</>
	}
</div>
